import * as React from "react";
import type { SVGProps } from "react";
const SvgIconStarFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 .32q-.35 0-.64.18-.29.19-.43.5L5.1 4.66v.02H5.1l-.03.01-4 .6q-.34.03-.6.23-.28.21-.4.55t-.04.67q.09.35.34.59l2.92 2.82h.01l.01.02v.02l-.7 4.08q-.05.34.07.65.14.33.41.53.28.2.62.22.35.03.65-.14l3.6-1.9h.08l3.6 1.9q.3.16.65.14.34-.04.62-.22.28-.21.4-.53.13-.31.08-.65l-.7-4.08v-.04h.02l2.92-2.82q.25-.24.34-.59.08-.33-.04-.67-.12-.33-.4-.55-.26-.2-.6-.24l-4-.59h-.03l-.01-.03L9.07 1Q8.92.69 8.64.5 8.34.32 8 .32"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconStarFilled;
